import ArcAPI from '../../api/arc';

const state = {
  access: { enabled: false, isConsultant: false, hasJourney: false, journeyId: null },
  journey: {},
  uiFlags: { fetchingAccess: false, fetchingJourney: false },
};

export const getters = {
  getAccess: $state => $state.access,
  getIsConsultant: $state => $state.access.isConsultant,
  getJourney: $state => $state.journey,
};

export const actions = {
  fetchAccess: async ({ commit }) => {
    commit('SET_ARC_UI', { fetchingAccess: true });
    try {
      const { data } = await ArcAPI.access();
      commit('SET_ARC_ACCESS', {
        enabled: data.enabled,
        isConsultant: data.is_consultant,
        hasJourney: data.has_journey,
        journeyId: data.journey_id,
      });
    } catch (error) {
      // silencioso: sem acesso => menu não aparece
    } finally {
      commit('SET_ARC_UI', { fetchingAccess: false });
    }
  },
  fetchJourney: async ({ commit }) => {
    commit('SET_ARC_UI', { fetchingJourney: true });
    try {
      const { data } = await ArcAPI.getJourney();
      commit('SET_ARC_JOURNEY', data);
    } finally {
      commit('SET_ARC_UI', { fetchingJourney: false });
    }
  },
  updateJourney: async ({ commit }, payload) => {
    const { data } = await ArcAPI.updateJourney(payload);
    commit('SET_ARC_JOURNEY', data);
    return data;
  },
};

export const mutations = {
  SET_ARC_ACCESS($state, access) {
    $state.access = access;
  },
  SET_ARC_JOURNEY($state, journey) {
    $state.journey = journey;
  },
  SET_ARC_UI($state, flags) {
    $state.uiFlags = { ...$state.uiFlags, ...flags };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
